import { doc, getDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { createContext, useContext, useReducer } from "react";
import { db } from "../firebase";
import { AuthContext } from "./AuthContext";

export const ChatContext = createContext();

export const ChatContextProvider = ({ children }) => {
  const { currentUser } = useContext(AuthContext);
  const [members, setMembers] = useState([]);

  const INITIAL_STATE = {
    chatId: "null",
    user: {},
  };

  const chatReducer = (state, action) => {
    switch (action.type) {
      case "CHANGE_USER":
        return {
          user: action.payload,
          chatId: action.payload.chatId,
        };

      default:
        return state;
    }
  };

  const [state, dispatch] = useReducer(chatReducer, INITIAL_STATE);
  useEffect(() => {
    if (!state.user.isGroup) return;
    x();
    async function x() {
      let members = await getDoc(doc(db, "groups", state.chatId));
      if (members.exists()) {
        setMembers(members.data().members)
      }
    }
  }, [state.user]);
  return (
    <ChatContext.Provider value={{ data: state, dispatch, members: members }}>
      {children}
    </ChatContext.Provider>
  );
};
